/*
 * 1-Minute Maths
 * async-hooks-shim.js - browser stand-in for node:async_hooks
 *
 * expo-font's serverContext.web.js statically imports AsyncLocalStorage from node:async_hooks
 * for its SSR-only font preloading path (guarded by `typeof window`). That code never runs in
 * this client-only web build, but the static import still needs something to resolve to so the
 * module can load without throwing.
 */
class AsyncLocalStorage {
  getStore() {
    return undefined;
  }

  run(_store, callback) {
    return callback();
  }
}

module.exports = { AsyncLocalStorage };
